import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Layout from './components/Layout'
import { useAuthStore } from './stores/useAuthStore'
import LoginPage from './pages/LoginPage'
import InvitePage from './pages/InvitePage'
import MovementsPage from './pages/MovementsPage'
import MovementDetailPage from './pages/MovementDetailPage'
import ImportPage from './pages/ImportPage'
import ExportPage from './pages/ExportPage'
import VehiclesPage from './pages/VehiclesPage'
import VehicleDetailPage from './pages/VehicleDetailPage'
import TripsPage from './pages/TripsPage'
import TripFormPage from './pages/TripFormPage'
import UsersPage from './pages/admin/UsersPage'
import SettingsPage from './pages/admin/SettingsPage'

function Protected({ children, adminOnly = false }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { user, loaded } = useAuthStore()
  const location = useLocation()
  if (!loaded) return <div className="p-10 text-center text-slate-400">Načítání…</div>
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />
  if (adminOnly && !user.isAdmin) return <Navigate to="/doklady" replace />
  return <Layout>{children}</Layout>
}

export default function App() {
  const { load, loaded } = useAuthStore()

  useEffect(() => {
    load()
  }, [load])

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<InvitePage />} />
      <Route path="/doklady" element={<Protected><MovementsPage /></Protected>} />
      <Route path="/doklady/:id" element={<Protected><MovementDetailPage /></Protected>} />
      <Route path="/import" element={<Protected><ImportPage /></Protected>} />
      <Route path="/export" element={<Protected><ExportPage /></Protected>} />
      <Route path="/vozidla" element={<Protected><VehiclesPage /></Protected>} />
      <Route path="/vozidla/:id" element={<Protected><VehicleDetailPage /></Protected>} />
      <Route path="/cesty" element={<Protected><TripsPage /></Protected>} />
      <Route path="/cesty/:id" element={<Protected><TripFormPage /></Protected>} />
      <Route path="/admin/users" element={<Protected adminOnly><UsersPage /></Protected>} />
      <Route path="/admin/nastaveni" element={<Protected adminOnly><SettingsPage /></Protected>} />
      <Route path="*" element={<Navigate to={loaded ? '/doklady' : '/login'} replace />} />
    </Routes>
  )
}
